import React, { useState, useEffect } from "react";
import { connect } from "react-redux";
import axios from "axios";

import * as retry from "retry";
// import axiosRetry from "axios-retry";

import { logOutUser } from "../reduxStore/actions/auth";
import Model from "../components/modal";
import { store } from "../reduxStore/store";

// axiosRetry(axios, { retries: 2 });
// Exponential back-off retry delay between requests
// axiosRetry(axios, { retries: 2, retryDelay: axiosRetry.exponentialDelay, retryCondition: (err) => {
//   // if (typeof err === "object" && err.stack && err.stack.includes("Network Error")) {
//   //   console.log("Network error, so I'll retry");
//   //   return true;
//   // }
//   return false;
// }});

const MakeAPICall = props => {
  const [errorModelOpen, seterrorModelOpen] = useState(false);
  const [errorModelBody, seterrorModelBody] = useState("");
  const [errorModelTitle, seterrorModelTitle] = useState("");

  const closeErrorModel = () => {
    seterrorModelBody();
    seterrorModelTitle();
    seterrorModelOpen(false);
  };

  const openErrorModel = (title, body) => {
    seterrorModelTitle(title);
    seterrorModelBody(body);
    seterrorModelOpen(true);
  };

  const makeRequest = (
    reqType,
    reqUrl,
    dataObj,
    params,
    headers,
    successCallback,
    failureCallback,
    showPopUp,
    timeout,
    showErrPopup
  ) => {
    let appendedHeader = {};
    if (
      Object.entries(headers).length === 0 &&
      headers.constructor === Object
    ) {
      appendedHeader = {
        Authorization:
          "Bearer " +
          (store.getState().auth.user && store.getState().auth.user.accessToken
            ? store.getState().auth.user.accessToken
            : "")
      };
    } else {
      appendedHeader = headers;
    }

    const operation = retry.operation({
      retries: 2,
      factor: 3,
      maxTimeout: 60 * 1000
    });

    operation.attempt(async currentAttempt => {
      try {
        await axios({
          method: reqType,
          url: reqUrl,
          headers: appendedHeader,
          data: dataObj,
          params: params,
          timeout: timeout,
          onUploadProgress: function(progressEvent) {
            // Do whatever you want with the native progress event
            //console.log("API call on process");
          },
          onDownloadProgress: function(progressEvent) {
            // Do whatever you want with the native progress event
            //console.log("API call on Download process");
          }
        }).then(res => {
          if (showPopUp) {
            openErrorModel("Instant Consult", res.data.message || "Success");
          }
          successCallback(res);
        });
      } catch (err) {
        // if (operation.retry(e)) { return; }
        console.log("Axios error catch : ", err);
        if (
          typeof err === "object" &&
          err.stack &&
          err.stack.includes("Network Error") &&
          currentAttempt <= 2
        ) {
          console.log("Network error, so I'll retry");
          if (operation.retry(err)) {
            return;
          }
        }
        if (err.response) {
          if (
            err.response.data.statusCode === 401 &&
            err.response.data.error === "Unauthorized"
          ) {
            openErrorModel(
              "Instant Consult",
              <p className="text-center mb-0">Unauthorized Request</p>
            );
          } else if (
            (err.response.data.statusCode === 403 &&
            err.response.data.type === "SESSION_EXPIRED") ||
            (err.response.data.statusCode === 401 &&
            err.response.data.type === "INVALID_CREDENTIALS")
          ) {
            openErrorModel(
              "Instant Consult",
              <p className="text-center mb-0">
                You are signed out. Please login again.
              </p>
            );
            setTimeout(() => {
              logOut();
            }, 1500);
          } else if (showErrPopup != false) {
            openErrorModel(
              "Instant Consult",
              err.response && err.response.data && err.response.data.message ? (
                <p className="text-center mb-0">{err.response.data.message}</p>
              ) : (
              <p className="text-center mb-0">
                Please try again. <br /> Please contact Instant Consult Support{" "}
                <br /> on 1300 003 310 if this issue persists.
              </p>
                )
            );
            failureCallback(
              err.response && err.response.data
                ? err.response.data
                : err.response
            );
          } else {
            failureCallback(
              err.response && err.response.data
                ? err.response.data
                : err.response
            );
          }
        } else {
          failureCallback({
            message:
              "Please try again. Please contact Instant Consult Support on 1300 003 310 if this issue persists."
          });
        }
      }
    });
  };

  useEffect(() => {
    if (props.apiParam) {
      makeRequest(
        props.apiParam.reqType,
        props.apiParam.reqUrl,
        props.apiParam.dataObj ? props.apiParam.dataObj : {},
        props.apiParam.params ? props.apiParam.params : {},
        props.apiParam.headers ? props.apiParam.headers : {},
        props.apiParam.successCallback,
        props.apiParam.failureCallback,
        props.apiParam.showPopUp ? props.apiParam.showPopUp : false,
        props.apiParam.timeout ? props.apiParam.timeout : 60000,
        props.apiParam.showErrPopup === false ? false : true
      );
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [props.apiParam]);

  const logOut = async () => {
    await props.logOutUser();
  };

  return (
    <Model
      openModal={errorModelOpen}
      modalBodyContent={errorModelBody}
      cancelText="Okay"
      title={errorModelTitle}
      useOneButton={true}
      okayEvent={closeErrorModel}
      cancelEvent={closeErrorModel}
    />
  );
};

const mapStateToProps = props => ({});

const mapDispatchToProps = dispatch => ({
  logOutUser: () => dispatch(logOutUser())
});

export default connect(mapStateToProps, mapDispatchToProps)(MakeAPICall);
